function getControlOptions() {
	return [
		{ id: "add-checkbox" },
		{ id: "add-radio" }
	];
}

function getImageOptions() {
	return [
		{ id: "add-image-cell" },
		{ id: "add-image-top" }
	];
}

function getGraphOptions() {
	return [
		{ id: "add-sparkline" },
		{ id: "add-chart" }
	];
}

// options for 'format' select
function getCellFormats(group){
	const suffix = group ? `-${group}` : "";
	return [
		{ id: "common" + suffix },
		{ id: "price" + suffix, example: "98.20" },
		{ id: "int" + suffix, example: "2120.02" },
		{ id: "percent" + suffix, example: "0.5" },
		{ id: "date" + suffix, example: "45000" },
		{ id: "string" + suffix, example: "012345" },
		{ id: "custom" + suffix },
	];
}

// options for 'font-family' select
export const fontFamily = [
	{ id: "Arial", value: "Arial" },
	{ id: "'Roboto', sans-serif", value: "Roboto" },
	{ id: "'PT Sans', Tahoma", value: "PT Sans" },
	{ id: "'Open Sans', sans-serif", value: "Open Sans" },
	{ id: "Tahoma", value: "Tahoma" },
	{ id: "Verdana", value: "Verdana" },
	{ id: "Calibri, Tahoma", value: "Calibri" },
];

export function getColumnOperation(){
	return [
		{ id: "add-column" },
		{ id: "del-column" },
		{ id: "show-column" },
		{ id: "hide-column" },
		{ id: "resize-column" },
		{ $template: "Separator" },
		{ id: "group-column" },
		{ id: "ungroup-column" },
		{ $template: "Separator" },
		{ id: "format-column", submenu: getCellFormats("column") },
	];
}

export function getRowOperation(){
	return [
		{ id: "add-row" },
		{ id: "del-row" },
		{ id: "show-row" },
		{ id: "hide-row" },
		{ id: "resize-row" },
		{ $template: "Separator" },
		{ id: "group-row" },
		{ id: "ungroup-row" },
		{ $template: "Separator" },
		{ id: "format-row", submenu: getCellFormats("row")},
	];
}

export function getClearOperation(){
	return [
		{ id: "clear-value" },
		{ id: "clear-style" },
		{ id: "clear-conditional-formats" },
		{ id: "clear-dropdown-editors" },
		{ id: "clear-filters" },
		{ id: "clear-comments" },
		{ $template: "Separator" },
		{ id: "clear-all" },
	];
}

export function getValidationOptions(){
	return [
		{ id: "add-cell-validation" },
		{ id: "remove-cell-validation" },
		{ id: "highlight-invalid-data" },
		{ id: "remove-highlight-invalid-data" }
	];
}

function getVerticalAlignOptions(){
	return [
		{ id: "top", css: "webix_ssheet_icon ssi-top" },
		{ id: "middle", css: "webix_ssheet_icon ssi-middle" },
		{ id: "bottom", css: "webix_ssheet_icon ssi-bottom" }
	];
}

function getTextAlignOptions() {
	return [
		{ id: "left", css: "webix_ssheet_icon ssi-left" },
		{ id: "center", css: "webix_ssheet_icon ssi-center" },
		{ id: "right", css: "webix_ssheet_icon ssi-right" }
	];
}

// options for 'font-size' select
function getFontSize(){
	return [
		{ id: "8px", value: "8" },
		{ id: "9px", value: "9" },
		{ id: "10px", value: "10" },
		{ id: "11px", value: "11" },
		{ id: "12px", value: "12" },
		{ id: "14px", value: "14" },
		{ id: "15px", value: "15" },
		{ id: "16px", value: "16" },
		{ id: "18px", value: "18" },
		{ id: "20px", value: "20" },
		{ id: "22px", value: "22" },
		{ id: "24px", value: "24" },
		{ id: "28px", value: "28" },
		{ id: "36px", value: "36" },
	];
}

function getBorderOptions() { 
	return [
		{ id: "no" },
		{ id: "left" },
		{ id: "top" },
		{ id: "right" },
		{ id: "bottom" },
		{ id: "all" },
		{ id: "outer" },
		{ id: "top-bottom" },
	];
}

const sortRange = [
	{ id: "sort-asc" },
	{ id: "sort-desc" },
	{ id: "sort-custom" },
];

const sortSheet = [
	{ id: "sort-sheet-asc" },
	{ id: "sort-sheet-desc" },
];

export const toolbarOptionMap = {
	format: getCellFormats(),
	"font-family": fontFamily,
	column: getColumnOperation(),
	row: getRowOperation(),
	clear: getClearOperation(),
	validation: getValidationOptions(),
	"vertical-align": getVerticalAlignOptions(),
	"text-align": getTextAlignOptions(),
	"font-size": getFontSize(),
	borders: getBorderOptions(),
	image: getImageOptions(),
	graph: getGraphOptions(),
	controls: getControlOptions(),
	"sort-range": sortRange,
	"sort-sheet": sortSheet,
};

export function editMenu(){
	return [
		{ id: "sort-range", submenu: toolbarOptionMap["sort-range"], menuOrder: 0 },
		{ id: "create-filter", menuOrder: 2 },
		{ id: "conditional-format", menuOrder: 4 },
		{ id: "add-link", menuOrder: 6 },
		{ id: "clear", submenu: toolbarOptionMap["clear"], menuOrder: 8 },
		{ id: "find", menuOrder: 10 },
		
		{ id: "sort-sheet", submenu: toolbarOptionMap["sort-sheet"], menuOrder: 1 },
		{ id: "add-range", menuOrder: 3 },
		{ id: "lock-cell", menuOrder: 5 },
		{ id: "add-dropdown", menuOrder: 7 },
		{ id: "validation", submenu: toolbarOptionMap["validation"], menuOrder: 9 },
	];
}

export const commonStructure = [
	{
		id: "file",
		submenu: [
			{
				id: "sheet",
				toolbarHeight: 2,
				toolbarWidth: 2,
				menuOrder: 0,
				toolbarLabel: true,
				view: "ssheet-button-icon-top",
				submenu:[
					{ id: "new-sheet" },
					{ id: "copy-sheet" },
					{ id: "remove-sheet" },
					{ id: "hide-sheet" },
				]
			},
			{ id: "excel-import", menuOrder: 1 },
			{ id: "print", menuOrder: 3 },   
			{ id: "excel-export", menuOrder: 2 }, 
			{ id: "print-borders", menuOrder: 4 }
		]
	},
	{
		id: "undo-redo",
		submenu: [
			{ 
				id: "undo", 
				toolbarWidth: 2, 
				toolbarLabel: true, 
				view: "ssheet-button" 
			},
			{ 
				id: "redo", 
				toolbarWidth: 2, 
				toolbarLabel: true, 
				view: "ssheet-button" 
			},
		]
	},
	{
		id: "font",
		submenu: [
			{ id: "font-family", toolbarWidth: 4, submenu: toolbarOptionMap["font-family"] },
			{ id: "font-size", submenu: toolbarOptionMap["font-size"] },
			{ id: "borders", menu: false, submenu: toolbarOptionMap["borders"] },
			{ id: "font-weight", toolbarWidth: 1 },
			{ id: "font-style", toolbarWidth: 1 },
			{ id: "underline", toolbarWidth: 1 },
			{ id: "strike", toolbarWidth: 1 },
			{ id: "background", menu: false },
			{ id: "color", menu: false },
		]
	},
	{
		id: "align",
		submenu: [
			{ id: "text-align", submenu: toolbarOptionMap["text-align"], menuOrder: 0 },
			{ id: "span", menuOrder: 2 },
			{ id: "increase-indent", menuOrder: 4 },
			{ id: "vertical-align", submenu: toolbarOptionMap["vertical-align"], menuOrder: 1 },
			{ id: "wrap", menuOrder: 3 },
			{ id: "decrease-indent", menuOrder: 5 },
		]
	},
	{
		id: "number",
		submenu: [
			{ 
				id: "format", 
				toolbarWidth: 3,
				submenu: toolbarOptionMap["format"]
			},
			{ id: "increase-decimals" },
			{ id: "decrease-decimals" },
		]
	},
	{
		id: "edit",
		submenu: editMenu()
	},
	{
		id: "insert",
		submenu: [
			{
				id: "image",
				toolbarWidth: 3,
				view: "ssheet-button", 
				toolbarLabel: true,
				submenu: toolbarOptionMap["image"]
			},
			{ 
				id: "add-comment", 
				toolbarWidth: 3,
				view: "ssheet-button", 
				toolbarLabel: true, 
			},
			{
				id: "graph",
				toolbarWidth: 3,
				view: "ssheet-button", 
				toolbarLabel: true,
				submenu: toolbarOptionMap["graph"]
			},
			{
				id: "controls", 
				toolbarWidth: 3,
				view: "ssheet-button", 
				toolbarLabel: true,
				submenu: toolbarOptionMap["controls"]
			},
		]
	},
	{
		id: "view",
		submenu: [
			{ id: "row", submenu: toolbarOptionMap["row"], menuOrder: 0 },
			{ id: "hide-gridlines", menuOrder: 2 },
			{ id: "freeze-rows", menuOrder: 4 },
			{ id: "show-formulas", menuOrder: 6 },
			{ id: "column", submenu: toolbarOptionMap["column"], menuOrder: 1 },
			{ id: "hide-headers", menuOrder: 3 },
			{ id: "freeze-columns", menuOrder: 5 },
		]
	},
];

export const readonlyStructure = [
	{
		id: "file",
		submenu: [
			{ id: "excel-export" },
			{ id: "print" },
			{ id: "print-borders" },
		]
	},
	{
		id: "view",
		submenu: [
			{ id: "hide-gridlines" },
			{ id: "hide-headers" },
			{ id: "show-formulas" },
		]
	},
	{
		id: "other",
		submenu: [
			{ id: "find-readonly" }
		]
	},
];